import React from 'react'
import { defaultProps } from './index'
import { ToolbarSection } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarSection'
import { ToolbarItem } from '../../editor/Viewport/Sidebar/Toolbar/ToolbarItem'
import LayoutToolbarSection from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/LayoutToolbarSection'

export const IconsSectionSettings = (settingsProps) => {
  const themeOpts = [
    { label: 'White', value: 'white' },
    { label: 'Neutral 10', value: 'neutral10' },
    { label: 'Neutral 20', value: 'neutral20' },
  ]

  return (
    <>
      <ToolbarSection title="Settings" initOpen>
        <ToolbarItem
          propKey="block"
          propSubKey="theme"
          type="select"
          options={themeOpts}
          label="Sfondo"
          defaultValue={defaultProps['theme']}
        />
      </ToolbarSection>
      {!settingsProps.floating && <LayoutToolbarSection defaultProps={defaultProps} />}
    </>
  )
}

export const IconsSectionFloatingSettings = () =>
  React.createElement(IconsSectionSettings, { floating: true })
